import React from "react"
import { Link } from "gatsby"
import Headroom from "react-headroom"

import { StyledLink, Nav, Logo } from "./style"

import img_logo from "../../../static/logo.png"

const NavBar = () => (
  <Headroom calcHeightOnResize disableInlineStyles>
    <StyledLink to="/">
      <Logo src={img_logo} alt="Gatsby Logo" />
    </StyledLink>
    <Nav>
      <Link to="/">Home</Link>
      <Link to="/blog">Blog</Link>
      <Link to="/contact">Contact</Link>
    </Nav>
  </Headroom>
)

export default NavBar
